import {DialogButtonTypesEnum, DialogConfigInterface} from '../../../app/shared/components/dialog';

import {AddFeeMessages} from '../../messages';

export const AddFeeDialogConfig = (isValidityUpdate = false): DialogConfigInterface => {
    return {
        process: {
            loading: false,
            finished: false,
            failed: false,
            failedMessage: '',
            succeedMessage: (isValidityUpdate ? AddFeeMessages.FeeUpdateSucceed.message : AddFeeMessages.FeeAssignmentSucceed.message)
        },
        buttons: [
            {
                type: DialogButtonTypesEnum.Cancel
            },
            {
                type: DialogButtonTypesEnum.Submit
            }
        ],
        buttonsDisabled: false,
        buttonsHidden: false
    };
};
